"use client";

import { useTranslations } from "next-intl";
import { type ReactNode } from "react";

export function FooterLicense(): ReactNode {
  const t = useTranslations("Index");
  return t.rich("travelLicense", {
    li: (chunks) => (
      <span>
        {chunks}
        <br />
      </span>
    ),
  });
}
